import type { WorkspaceGenericInputCreateRequest, WorkspaceInputCreateRequest } from 'googleworkspace/types';
import type { FormData } from 'googleworkspace/context/FormData';

export const toWorkspaceInputCreateRequest = ({
  accountId,
  secretPath,
  logs,
  workspaceName,
  workspaceThrottleEnabled,
  pollingInterval,
  clientId,
  accountUser,
}: FormData): WorkspaceInputCreateRequest => ({
  name: workspaceName.value,
  log_types: logs.value.split(','),
  polling_interval: pollingInterval.value,
  polling_time_unit: 'MINUTES',
  workspace_client_id: clientId.value,
  workspace_account_id: accountId.value,
  enable_throttling: !!workspaceThrottleEnabled?.value,
  workspace_account_user: accountUser.value,
  workspace_secret_path: secretPath.value,
});

export const toGenericInputCreateRequest = ({
  accountId,
  secretPath,
  logs,
  workspaceName,
  clientId,
  workspaceThrottleEnabled,
  pollingInterval,
  accountUser,
}: FormData): WorkspaceGenericInputCreateRequest => ({
  type: 'org.graylog.enterprise.integrations.googleworkspace.WorkspaceInput',
  title: workspaceName.value,
  global: false,
  configuration: {
    log_types: logs.value.split(','),
    polling_interval: pollingInterval.value,
    polling_time_unit: 'MINUTES',
    client_id:clientId.value,
    account_id: accountId.value,
    throttling_allowed: !!workspaceThrottleEnabled?.value,
    account_user: accountUser.value,
    secret_path: secretPath.value,
  },
});
